export default "__VITE_PUBLIC_ASSET__50b7d370__"